import { Action } from '@ngrx/store';
import { UserGroup } from '../../_models/user_group';
import { UserZone} from '../../_models/user_zone';
import { Zone } from '../../_models/zone';

export enum UserGroupActitonTypes {

  ClearUserGroup = '[UserGroup] Clear',
  InicializeUserGroup = '[UserGroup] Inicialize',

	SetCurrentUserGroup = '[UserGroup] Set Current',
	SetCurrentUserGroupId = '[UserGroup] Set Current Id',

	SetFilterFields = '[UserGroup] Set Filter Fields',

	LoadUserGroups = '[UserGroup] Get List',
	LoadUserGroupsSuccess = '[UserGroup] Load Success',
  LoadUserGroupsFail = '[UserGroup] Load Fail',

  UpdateUserGroup = '[UserGroup] Update',
  UpdateUserGroupSuccess = '[UserGroup] Update Success',
	UpdateUserGroupFail = '[UserGroup] Update Fail',

	CreateUserGroup = '[UserGroup] Create',
  CreateUserGroupSuccess = '[UserGroup] Create Success',
	CreateUserGroupFail = '[UserGroup] Create Fail',

	DeleteUserGroup = '[UserGroup] Delete',
  DeleteUserGroupSuccess = '[UserGroup] Delete Success',
	DeleteUserGroupFail = '[UserGroup] Delete Fail',

	LoadUserZones = '[ProdData] Load LoadUserZones',
	LoadUserZonesSuccess = '[ProdData] Load LoadUserZones Success',
	LoadUserZonesFail = '[ProdData] Load LoadUserZones Fail',

	DeleteUserZone = '[UserGroup] Delete UserZone',
  DeleteUserZoneSuccess = '[UserGroup] Delete UserZone Success',
	DeleteUserZoneFail = '[UserGroup] Delete UserZone Fail',

	CreateUserZone = '[UserGroup] Create UserZone',
  CreateUserZoneSuccess = '[UserGroup] Create UserZone Success',
	CreateUserZoneFail = '[UserGroup] Create UserZone Fail',

	LoadZones = '[UserGroup] Load LoadZones',
	LoadZonesSuccess = '[UserGroup] Load LoadZones Success',
	LoadZonesFail = '[UserGroup] Load LoadZones Fail',
}

export class ClearUserGroup implements Action {
	readonly type = UserGroupActitonTypes.ClearUserGroup;
}

export class InicializeUserGroup implements Action {
	readonly type = UserGroupActitonTypes.InicializeUserGroup;
}

export class SetCurrentUserGroup implements Action {
	readonly type = UserGroupActitonTypes.SetCurrentUserGroup;

	constructor(public payload: UserGroup) {}
}

export class SetCurrentUserGroupId implements Action {
	readonly type = UserGroupActitonTypes.SetCurrentUserGroupId;

	constructor(public payload: bigint) {}
}

export class SetFilterFields implements Action {
	readonly type = UserGroupActitonTypes.SetFilterFields;

	constructor(public payload: any) {}
}

export class LoadUserGroups implements Action {
	readonly type = UserGroupActitonTypes.LoadUserGroups;

	constructor(public payload: any) {}
	// constructor(public payload: {
    //   finished: boolean,
    //   searchDesc: string,
    //   searchName: string
    // }) {}
}

export class LoadUserGroupsSuccess implements Action {
	readonly type = UserGroupActitonTypes.LoadUserGroupsSuccess;

	constructor(public payload: UserGroup[]) {}
}

export class LoadUserGroupsFail implements Action {
	readonly type = UserGroupActitonTypes.LoadUserGroupsFail;

	constructor(public payload: string) {}
}

export class UpdateUserGroup implements Action {
	readonly type = UserGroupActitonTypes.UpdateUserGroup;

	constructor(public payload: UserGroup) {}
}

export class UpdateUserGroupSuccess implements Action {
	readonly type = UserGroupActitonTypes.UpdateUserGroupSuccess;

	constructor(public payload: UserGroup) {}
}

export class UpdateUserGroupFail implements Action {
	readonly type = UserGroupActitonTypes.UpdateUserGroupFail;

	constructor(public payload: string) {}
}

export class DeleteUserGroup implements Action {
	readonly type = UserGroupActitonTypes.DeleteUserGroup;

	constructor(public payload: UserGroup) {}
}

export class DeleteUserGroupSuccess implements Action {
	readonly type = UserGroupActitonTypes.DeleteUserGroupSuccess;

	constructor(public payload: bigint) {}
}

export class DeleteUserGroupFail implements Action {
	readonly type = UserGroupActitonTypes.DeleteUserGroupFail;

	constructor(public payload: string) {}
}

export class CreateUserGroup implements Action {
	readonly type = UserGroupActitonTypes.CreateUserGroup;

	constructor(public payload: UserGroup) {}
}

export class CreateUserGroupSuccess implements Action {
	readonly type = UserGroupActitonTypes.CreateUserGroupSuccess;

	constructor(public payload: UserGroup) {}
}

export class CreateUserGroupFail implements Action {
	readonly type = UserGroupActitonTypes.CreateUserGroupFail;

	constructor(public payload: string) {}
}

// -------- ZONAS --------
export class LoadUserZones implements Action {
	readonly type = UserGroupActitonTypes.LoadUserZones;

	constructor(public payload: any) {}
}

export class LoadUserZonesSuccess implements Action {
	readonly type = UserGroupActitonTypes.LoadUserZonesSuccess;

	constructor(public payload: UserZone[]) {}
}

export class LoadUserZonesFail implements Action {
	readonly type = UserGroupActitonTypes.LoadUserZonesFail;

	constructor(public payload: string) {}
}

export class LoadZones implements Action {
	readonly type = UserGroupActitonTypes.LoadZones;

	constructor(public payload: any) {}
}

export class LoadZonesSuccess implements Action {
	readonly type = UserGroupActitonTypes.LoadZonesSuccess;

	constructor(public payload: Zone[]) {}
}

export class LoadZonesFail implements Action {
	readonly type = UserGroupActitonTypes.LoadZonesFail;

	constructor(public payload: string) {}
}

export class DeleteUserZone implements Action {
	readonly type = UserGroupActitonTypes.DeleteUserZone;

	constructor(public payload: UserZone) {}
}

export class DeleteUserZoneSuccess implements Action {
	readonly type = UserGroupActitonTypes.DeleteUserZoneSuccess;

	constructor(public payload: bigint) {}
}

export class DeleteUserZoneFail implements Action {
	readonly type = UserGroupActitonTypes.DeleteUserZoneFail;

	constructor(public payload: string) {}
}

export class CreateUserZone implements Action {
	readonly type = UserGroupActitonTypes.CreateUserZone;

	constructor(public payload: UserZone) {}
}

export class CreateUserZoneSuccess implements Action {
	readonly type = UserGroupActitonTypes.CreateUserZoneSuccess;

	constructor(public payload: UserZone) {}
}

export class CreateUserZoneFail implements Action {
	readonly type = UserGroupActitonTypes.CreateUserZoneFail;

	constructor(public payload: string) {}
}

// Unión de acciones
export type UserGroupActions = ClearUserGroup
| InicializeUserGroup
| SetCurrentUserGroup
| SetCurrentUserGroupId
| SetFilterFields
| UpdateUserGroup
| UpdateUserGroupSuccess
| UpdateUserGroupFail
| CreateUserGroup
| CreateUserGroupSuccess
| CreateUserGroupFail
| DeleteUserGroup
| DeleteUserGroupSuccess
| DeleteUserGroupFail
| LoadUserGroups
| LoadUserGroupsSuccess
| LoadUserGroupsFail
| LoadUserZones
|	LoadUserZonesSuccess
|	LoadUserZonesFail
|	LoadZones
|	LoadZonesSuccess
|	LoadZonesFail
| DeleteUserZone
| DeleteUserZoneSuccess
| DeleteUserZoneFail
| CreateUserZone
| CreateUserZoneSuccess
| CreateUserZoneFail;
